<template>
    <div>
        <div class="main_content">
            <location-line />
            <common-data-table hover class="" :totalPage="totalPage" :curPage="curPage">
                <template slot="header">
                    <b-thead>
                        <b-tr>
                            <b-th> 대상 </b-th>
                            <b-th> 수집방법 </b-th>
                            <b-th> 수집요청인 </b-th>
                            <b-th> 수집 요청일시 </b-th>
                            <b-th> 수집 종료일시 </b-th>
                        </b-tr>
                    </b-thead>
                </template>
                <template slot="body">
                    <b-tbody>
                        <b-tr v-for="(item, index) in items" :key="index">
                            <b-td> {{ item.id }} </b-td>
                            <b-td> {{ item.type }} </b-td>
                            <b-td> {{ item.req }} </b-td>
                            <b-td> {{ item.indate }} </b-td>
                            <b-td> {{ item.outdate }} </b-td>
                        </b-tr>
                    </b-tbody>
                </template>
            </common-data-table>
        </div>
    </div>
</template>

<script>
import commonDataTable from '@/components/common/table/DataTable'
import LocationLine from '@/components/LocationLine'
import ax from '@/api/lbs'

export default {
    components: {
        commonDataTable,
        LocationLine
    },

    data() {
        return {
            curPage: parseInt(this.$route.query.page) || 1,
            totalPage: 1,
            items: []
        }
    },

    created() {
        this.init()
    },

    methods: {
        init() {
            ax.termList(this.curPage, (data) => {
                if (data) {
                    this.items = data.items
                    this.totalPage = data.totalPage
                } else {
                    this.items = []
                    this.totalPage = 1
                }
            })
        }
    },

    watch: {
        '$route.query': function () {
            this.curPage = parseInt(this.$route.query.page) || 1
            this.init()
        }
    }
}
</script>